// src/pages/PublicNonFilerAffidavit.jsx
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

export default function PublicNonFilerAffidavit() {
  const { tokenId } = useParams();
  const [state, setState] = useState({ loading: false, ok: false, message: "" });
  const [hasConfirmed, setHasConfirmed] = useState(false);

  const submitAffidavit = async () => {
    if (state.loading) return;
    setHasConfirmed(true);
    setState({ loading: true, ok: false, message: "" });

    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/public/tax-return/${tokenId}/non-filer/`, {
        method: "POST",
      });
      const data = await res.json().catch(() => ({}));

      if (!res.ok) {
        setState({ loading: false, ok: false, message: data.detail || "Something went wrong." });
        return;
      }

      setState({ loading: false, ok: true, message: data.detail || "Affidavit submitted." });
    } catch (e) {
      setState({ loading: false, ok: false, message: "Network error. Please try again." });
    }
  };

  useEffect(() => {
    // Intentionally do nothing on mount.
    // This page requires explicit confirmation before submitting.
  }, [tokenId]);

  return (
    <div className="min-h-screen bg-gray-100 text-gray-900 flex items-center justify-center p-6">
      <div className="w-full max-w-lg bg-white rounded-2xl p-6 ring-1 ring-gray-200 shadow">
        <h1 className="text-2xl font-semibold mb-2">Tax Return Status</h1>
        {!hasConfirmed && !state.ok && !state.message ? (
          <>
            <p className="text-gray-700 leading-relaxed">
              By clicking confirm, you certify that you are <span className="font-semibold">not required</span> to file a tax return for this year.
              We will generate and submit an affidavit to your case.
            </p>
            <div className="mt-5 flex gap-3">
              <button
                type="button"
                onClick={submitAffidavit}
                className="inline-flex items-center justify-center rounded-xl bg-indigo-600 px-4 py-2 font-semibold text-white hover:bg-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-400/60"
              >
                Confirm & Submit Affidavit
              </button>
            </div>
            <p className="text-sm text-gray-500 mt-4">
              If you reached this page by mistake, you can close it.
            </p>
          </>
        ) : state.loading ? (
          <p className="text-gray-700">Submitting your affidavit…</p>
        ) : state.ok ? (
          <>
            <p className="text-green-600">{state.message}</p>
            <p className="text-sm text-gray-500 mt-4">You can close this page.</p>
          </>
        ) : (
          <>
            <p className="text-red-600">{state.message || "Something went wrong."}</p>
            <div className="mt-5">
              <button
                type="button"
                onClick={submitAffidavit}
                className="inline-flex items-center justify-center rounded-xl bg-indigo-600 px-4 py-2 font-semibold text-white hover:bg-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-400/60"
              >
                Try Again
              </button>
            </div>
            <p className="text-sm text-gray-500 mt-4">If you prefer, you can close this page and contact our office.</p>
          </>
        )}
      </div>
    </div>
  );
}